import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Holiday from '../../entities/casis/holiday'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface HolidayState extends ListState<Holiday>{
    editModel:Holiday;
    
}
class HolidayModule extends ListModule<HolidayState,any,Holiday>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Holiday>(),
        loading:false,
        editModel: new Holiday(),
        activeList: new Array<Holiday>(),
        path: 'holidays'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const holidayModule=new HolidayModule();
export default holidayModule;
